<template>
    <div class="top-image">
        <div class="top-image__bg" :style="'background-image: url('+bgImage+')'"></div>
        <div class="top-image__inner">
            <v-row>
                <v-col cols="12" md="5" class="mb-30 mb-md-0">
                    <v-img :src="image" max-width="586" width="100%"></v-img>
                </v-col>
                <v-col cols="12" md="7" lg="6" offset-lg="1">
                    <div class="pt-md-20 pt-lg-60">
                        <h3 class="tit top-line-tit mb-16 mb-md-50 mb-lg-110">
                            {{tit}}
                        </h3>
                        <slot />
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        tit: { type: String, default: "" },
        bgImage: { type: String, default: "" },
        image: { type: String, default: "" },
    },
    components: {
    },
    data: () => {
        return {};
    },
    created() {},
};
</script>

<style lang="scss" scoped>
.top-image{
    padding-top: 60px;
    position: relative;
}
.top-image__bg{
    position: absolute;
    width: 100vw;
    height: 310px;
    background-position: right center;
    background-repeat: no-repeat;
    background-size: cover;
    left: 50%;
    top: 0;
    z-index: 0;
    transform: translateX(-50%);
}
.top-image__inner{
    position: relative;
}
@media (min-width:576px){
}
@media (min-width:768px){
    .top-image{
        padding-top: 80px;
    }
}
@media (min-width:1024px){
    .top-image{
        padding-top: 100px;
    }
}
@media (min-width:1200px){
}
</style>
